import * as types from './action-types'

export const imageLoad = () => {
  return {
    type: types.IMAGE_LOAD
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/image-load.js